/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'concurrency-error',
    template: `
    <div *ngIf="message" class="concurrency-error-container">
      <div class="message">{{ message }}</div>
      <div class='flex-layout-row flex-layout-align-start-center flex-layout-gap-10px'>
		<button mat-button (click)="reload()"><mat-icon>refresh</mat-icon>Reload</button>
      </div>      
    </div>
  `,
    styles: [
        `
      .concurrency-error-container {
        margin-bottom: 5px;
      }
      .message {
        background-color: #c00;
        color: #fff;
        font-size: 0.9em;
        padding: 5px 10px;
        margin-bottom: 3px;
      }
    `
    ],
    standalone: false
})
export class ConcurrencyErrorComponent {
  @Input() message = '';
  @Output() reloadRequested = new EventEmitter<void>();

  constructor() {}

  reload() {
    this.reloadRequested.emit();
  }
}
